import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/joy';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

type Props = {
  crumb: string[];
};

const Breadcrumb = ({ crumb }: Props) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Breadcrumbs size='sm' aria-label='breadcrumbs' separator={<ChevronRightRoundedIcon fontSize='small' />} sx={{ pl: 0 }}>
        <Link underline='none' color='neutral' href='/dashboard' aria-label='Home'>
          <HomeRoundedIcon />
        </Link>
        {crumb.map((c, i) => {
          if (i !== crumb.length - 1) {
            return (
              <Link key={c} underline='hover' color='neutral' href={`/${c}`} fontSize={12} fontWeight={500}>
                {c}
              </Link>
            );
          } else {
            return (
              <Typography key={c} color='primary' fontWeight={500} fontSize={12}>
                {c}
              </Typography>
            );
          }
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
